// Canonical Fund column metadata, shared between the funds-overview table and the reusable
// valumize-fund-table so the two cannot drift. Column ids match the matColumnDef ids used in
// both templates.

export const FUND_COLUMN_GROUPS = [
    {label: "Main", cols: ["fundId", "fundName", "country", "currencyIso", "size", "mainFundSize", "vintageYear", "endYear"]},
];

export const FUND_COLUMN_LABELS: Record<string, string> = {
    fundId: "ID",
    fundName: "Fund",
    country: "Country",
    currencyIso: "Currency",
    size: "This Fund Size",
    mainFundSize: "Main Fund Size",
    vintageYear: "Vintage Year",
    endYear: "Fund Ends",
};

export const FUND_ALL_COLUMNS = FUND_COLUMN_GROUPS.flatMap(group => group.cols);

// valumize-fund-table is client-side (MatTableDataSource), so its sort keys are the matColumnDef
// ids — unlike the funds-overview table, which sorts server-side by backend field names. Keep
// these separate from the overview's SORTABLE_COLUMNS for that reason.
export const FUND_TABLE_DEFAULT_COLUMNS = ["fundName", "country", "currencyIso", "size", "mainFundSize", "vintageYear", "endYear"];

export const FUND_TABLE_SORTABLE_COLUMNS = [
    {value: "fundName", label: "Fund"},
    {value: "country", label: "Country"},
    {value: "currencyIso", label: "Currency"},
    {value: "size", label: "This Fund Size"},
    {value: "mainFundSize", label: "Main Fund Size"},
    {value: "vintageYear", label: "Vintage Year"},
    {value: "endYear", label: "Fund Ends"},
];
